import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]

import { computed, ref, toRefs, watch } from 'vue'
    import IconArrowLeft from '@/components/icons/IconArrowLeft.vue'
    import IconArrowRight from '@/components/icons/IconArrowRight.vue'
    import AnimateFadeIn from '@/components/animations/AnimateFadeIn.vue'
    import IconClose from '@/components/icons/IconClose.vue'

    interface Props {
        images: string[],
        imageIndex: number|null
    }

    
export default /*#__PURE__*/_defineComponent({
  props: {
    images: null,
    imageIndex: null
  },
  setup(__props: any) {

const props = __props as {
        images: string[],
        imageIndex: number|null
    }

    

    const { images } = toRefs(props)

    const activeImageIndex = ref<number|null>(props.imageIndex)

    const canGoPrev = computed<boolean>(() => (activeImageIndex.value || 0) > 0)
    const canGoNext = computed<boolean>(() => (activeImageIndex.value || 0) < images.value.length - 1)

    const goPrev = () => {
        if (activeImageIndex.value !== null) {
            activeImageIndex.value -= 1
        }
    }

    const goNext = () => {
        if (activeImageIndex.value !== null) {
            activeImageIndex.value += 1
        }
    }

    const updateActiveImageIndex = () => {
        activeImageIndex.value = props.imageIndex
    }

    watch(props, updateActiveImageIndex)

return (_ctx: any,_cache: any) => {
  return (activeImageIndex.value !== null)
    ? (_openBlock(), _createBlock(AnimateFadeIn, { key: 0 }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "image-gallery-overlay",
            onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$emit('hide',true); activeImageIndex.value = null})
          }, [
            _createElementVNode("img", {
              src: _unref(images)[activeImageIndex.value]
            }, null, 8, _hoisted_1),
            (_unref(canGoPrev))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "image-gallery-button image-gallery-button--prev",
                  onClick: _withModifiers(goPrev, ["stop"])
                }, [
                  _createVNode(IconArrowLeft, { size: 32 })
                ], 8, _hoisted_2))
              : _createCommentVNode("", true),
            (_unref(canGoNext))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "image-gallery-button image-gallery-button--next",
                  onClick: _withModifiers(goNext, ["stop"])
                }, [
                  _createVNode(IconArrowRight, { size: 32 })
                ], 8, _hoisted_3))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "image-gallery-button image-gallery-button--close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$emit('hide',true); activeImageIndex.value = null})
            }, [
              _createVNode(IconClose, { size: 32 })
            ])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})